export class ContentsForPagination<T> {
    totalContentsCount: number
    contents: T[]

    constructor(
        totalContentsCount: number,
        contents: T[],
    ) {
        this.totalContentsCount = totalContentsCount
        this.contents = contents
    }
}
